// HOLDOUTGROUP : holdout-q3-ice-barrel

// fuction to check holdout group ann add class ab-enabled
const checkHoldout = _ => {
    const holdoutGroup = window._growthbook?.getFeatureValue('holdout-q3-ice-barrel', 'OFF');
    if(holdoutGroup != 'holdout-q3-ice-barrel'){
        document.documentElement.classList.add("ab-enabled")
        window.ab_enabled = true
    }
}

(() => {
    window.growthbook_queue = window.growthbook_queue || [];
    window.growthbook_queue.push((gb) => {
        // Function that uses feature flags to make changes to the page
        const applyFeatureFlags = () => {
            // Active feature-flag calls are added here
        };
        // check holdout to set ab test
        checkHoldout()
        // Call your function initially plus whenever new data is received
        applyFeatureFlags();
        document.addEventListener("growthbookdata", _ => {
            checkHoldout()
            applyFeatureFlags()
        });
    });
})();